<script setup lang="ts">
import { computed } from 'vue';
import CoreIcon, { CoreIconProps } from '@core/core-icon.vue';

const props = defineProps<{
	icon?: CoreIconProps,
	url?: string,
	title: string
}>();

const componentName = computed(() => {
	return props?.url ? 'router-link' : 'button';
});
</script>

<template>
	<component
		:is="componentName"
		:to="url"
		class="button-navigation-link"

	>
		<core-icon
			v-if="icon"
			v-bind="icon"
			class="button-navigation-link__icon"
		/>
		<span v-if="title" class="button-navigation-link__title font-18-pro-medium">
			{{ title }}
		</span>
	</component>
</template>

<style lang="scss">
.button-navigation-link {
	padding: 0 1.6rem;
	height: 5rem;
	display: flex;
	align-items: center;
	gap: 1.6rem;
	fill: currentColor;
	border-radius: 1.2rem;
	transition: color 0.12s, background-color 0.12s, box-shadow 0.12s;

	// @include min-desktop {
	// 	&:hover {
	// 		color: var(--color-active);
	// 	}
	// }

	// Текущий пункт и наведение — та же тонировка акцентом, что у строк
	// кабинета; белая карточка с тенью выбивалась из нового стиля
	&.router-link-active {
		background-color: rgba(var(--color-active-rgb), 0.1);
		color: var(--color-active);
	}

	@media (hover: hover) and (pointer: fine) {
		&:hover {
			background-color: rgba(var(--color-active-rgb), 0.1);
			color: var(--color-active);
		}
	}

	&__icon {
		width: var(--icon-width, 1.8rem);
		flex: 0 0 auto;
	}
	&__title {
		flex: 0 1 auto;
		text-align: left;
	}
}
</style>
